"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PALETTE = void 0;
// Default categorical palette for Titan charts.
// Requirement: stable across client/server and distinguishable across common color-vision deficiencies.
exports.DEFAULT_PALETTE = [
    'rgb(255, 178, 122)',
    'rgb(255, 117, 87)',
    'rgb(226, 192, 68)',
    'rgb(68, 157, 209)',
    'rgb(249, 163, 164)',
    'rgb(13, 126, 160)',
    'rgb(19, 216, 170)',
    'rgb(114, 190, 244)',
    'rgb(86, 83, 254)',
    'rgb(41, 131, 255)',
    'rgb(0, 177, 242)',
    'rgb(206, 147, 216)',
    'rgb(240, 98, 146)',
    'rgb(0, 200, 83)',
    'rgb(186, 104, 200)'
];
//# sourceMappingURL=palette.js.map